export default __webpack_public_path__ + "static/media/canisters.a795c4ad.svg";